import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import DashboardLayout from "./pages/DashboardLayout";
import DashboardHome from "./pages/DashboardHome";
import CampaignsPage from "./pages/CampaignsPage";
import DevicesPage from "./pages/DevicesPage";
import LocationsPage from "./pages/LocationsPage";
import ActivityPage from "./pages/ActivityPage";
import VouchersPage from "./pages/VouchersPage";
import SettingsPage from "./pages/SettingsPage";
import StampPage from "./pages/StampPage";
import VoucherViewPage from "./pages/VoucherViewPage";
import OwnerDashboard from "./pages/OwnerDashboard";
import RedeemPage from "./pages/RedeemPage";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/como-funciona" element={<HowItWorksPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          <Route path="/privacidad" element={<PrivacyPage />} />
          <Route path="/terminos" element={<TermsPage />} />
          <Route path="/stamp/:deviceId" element={<StampPage />} />
          <Route path="/voucher/:voucherId" element={<VoucherViewPage />} />
          <Route path="/canjear" element={<RedeemPage />} />
          
          {/* Owner Dashboard (Protected) */}
          <Route path="/owner" element={
            <ProtectedRoute>
              <OwnerDashboard />
            </ProtectedRoute>
          } />
          
          {/* Protected Dashboard Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }>
            <Route index element={<DashboardHome />} />
            <Route path="campaigns" element={<CampaignsPage />} />
            <Route path="devices" element={<DevicesPage />} />
            <Route path="locations" element={<LocationsPage />} />
            <Route path="activity" element={<ActivityPage />} />
            <Route path="vouchers" element={<VouchersPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
